import axios from 'axios';

// Logout handler - will be set by AuthContext
let logoutHandler = null;

export const setLogoutHandler = (handler) => {
  logoutHandler = handler;
};

// Setup global axios interceptor for 401 handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || "";
      const isLoginEndpoint = requestUrl.includes("/auth/login");

      if (!isLoginEndpoint) {
        // Clear auth data from localStorage
        localStorage.removeItem("tali_client_token");
        localStorage.removeItem("tali_client_isLoggedIn");
        localStorage.removeItem("tali_client_userPayload");

        // Call the logout handler if set (updates React state)
        if (logoutHandler) {
          logoutHandler();
        }

        // Redirect to login page with session expired message
        if (window.location.pathname !== "/login") {
          window.location.href = "/login?session=expired";
        }
      }
    }
    return Promise.reject(error);
  }
);
